"use client";

import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { getCountries } from '../utils/contactus/contactus';

export interface Country {
    code: string;
    phone: string;
    countryName: string;
}

interface CountriesContextType {
    countries: Country[];
    loading: boolean;
}

const CountriesContext = createContext<CountriesContextType | undefined>(undefined);

export function CountriesProvider({ children }: { children: ReactNode }) {
    const [countries, setCountries] = useState<Country[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        // Load countries once on mount
        const loadCountries = async () => {
            setLoading(true);
            try {
                const fetchedCountries = await getCountries();
                setCountries(fetchedCountries);
            } catch (error) {
                console.error('Error loading countries:', error);
                setCountries([]);
            } finally {
                setLoading(false);
            }
        };

        loadCountries();
    }, []); // Empty dependency array - runs only once on mount

    const value: CountriesContextType = {
        countries,
        loading,
    };

    return (
        <CountriesContext.Provider value={value}>
            {children}
        </CountriesContext.Provider>
    );
}

export function useCountries(): CountriesContextType {
    const context = useContext(CountriesContext);
    if (context === undefined) {
        throw new Error('useCountries must be used within a CountriesProvider');
    }
    return context;
}

